var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_89729",
    "data-name": "Group 89729",
    transform: "translate(-287 -230)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3014",
    "data-name": "Ellipse 3014",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(287 230)",
    fill: "#7e59d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11307",
    "data-name": "Path 11307",
    d: "M135.107,167.983a.647.647,0,0,1-.462-.194l-2.392-2.431a.648.648,0,0,1,.924-.909l1.911,1.942,3.953-4.354a.648.648,0,1,1,.959.872l-4.414,4.862a.648.648,0,0,1-.467.213Z",
    transform: "translate(161.229 74.939)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIcon);
export default __webpack_public_path__ + "static/media/complete-icon.d6e118961199f368d24c28ae9cd210ba.svg";
export { ForwardRef as ReactComponent };